/**
 * Tenant Config — Initializes runtime URL overrides from Electron tenant IPC.
 *
 * When running in Electron with a tenant selected, this loads the tenant's URLs
 * into window.__CW_TENANT_URLS__ so that all process.env.REACT_APP_* references
 * (rewritten by Vite's define plugin) resolve to tenant-specific values.
 */

const tenantConfig = {
  /**
   * Load active tenant URLs into window.__CW_TENANT_URLS__.
   * Returns the active tenant object or null.
   */
  async initialize() {
    if (!window.electronAPI?.tenant) return null;

    try {
      const active = await window.electronAPI.tenant.getActive();
      if (!active) return null;

      const urls = await window.electronAPI.tenant.getUrls(active.code);
      if (urls && Object.keys(urls).length > 0) {
        window.__CW_TENANT_URLS__ = urls;
      } else {
        console.warn(`[TenantConfig] No URLs found for tenant '${active.code}'`);
      }

      return active;
    } catch (err) {
      console.error("[TenantConfig] Failed to initialize:", err);
      return null;
    }
  },

  /**
   * Clear tenant URL overrides (used when switching tenants before reload).
   */
  clear() {
    delete window.__CW_TENANT_URLS__;
  },
};

export default tenantConfig;
